<div class="d-md-flex flex-md-row-reverse justify-content-between container-title-repository">
  <app-link-repository [urlRepository]="urlRepository"></app-link-repository>
  <div class="title">
    <span [id]="idTitle">&nbsp;</span>
    <h2 class="title-1">{{title}}</h2>
    <h2 class="title-1">{{title2}}</h2>
  </div>
</div>
<p class="parrafo-1" style="text-align: justify;">
  {{description}}
</p>
<p class="parrafo-2" style="text-align: justify;">
  {{description1}}
</p>
<p class="parrafo-3" style="text-align: justify;">
  {{description2}}
</p>
<div class="container-entities">
  <div class="container-title-entities">
    <span>Requerido, mínimamente, en:</span>
  </div>
  <div  class="container-entitie">
    <ng-container *ngFor="let entitie of entitiesList">
      <span *ngIf="exist(entitie.name)">
        <a href="{{entitie.url}}" target="_blank">{{entitie.name}}</a>
      </span>
    </ng-container>
  </div>
</div>
<hr class="hr-divider">
